export const ZOO_RULE_PREFIX = 'zoo';
export var Zoo;
(function (Zoo) {
    Zoo["EditTimezone"] = "zoo:edit-timezone";
    Zoo["EditLocation"] = "zoo:edit-location";
    Zoo["ViewPartnerStatisticsLink"] = "zoo:view-partner-statistics-link";
})(Zoo || (Zoo = {}));
